/**
 * useSetRitualAudioCover Hook
 *
 * Sets the cover image (poster) on an existing audio upload attached to a
 * ritual. Used in the edit flow where audio is uploaded first and the
 * cover image is set as a follow-up call.
 */

import { useMutation, useQueryClient } from "@tanstack/react-query"
import { toast } from "sonner"
import { setRitualUploadCover } from "../services/ritual.service"

interface Variables {
  ritualId: string
  uploadId: string
  file: File
}

export function useSetRitualAudioCover() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ ritualId, uploadId, file }: Variables) =>
      setRitualUploadCover(ritualId, uploadId, file),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["ritual"] })
      toast.success("Audio cover updated")
    },
    onError: () => {
      toast.error("Failed to update audio cover")
    },
  })
}
